import(/* webpackMode: "eager" */ "/workspace/swishr-pulse-v-119f21a/src/app/[locale]/error.tsx");
